import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllPermissions } from "../../actions/userActions/permissionsAction";
import SearchInput from "../subComponents/search/SearchInput";
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomPagination from "../subComponents/pagination/CustomPagination";

function Permissions() {
  const dispatch = useDispatch();
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const permissionsData = useSelector(
    (state) => state.permissions_reducer.allPermissions
  );
  const totalPages = permissionsData?.totalPages || 0;
  const totalItems = permissionsData?.totalCount || 0;
  const permissions = permissionsData && permissionsData?.result && permissionsData.result[0].permissions || [];
  useEffect(() => {
    const body = {
      filter: {
        textSearch: query,
        permissionGroup: [0],
      },
      pageNumber: currentPage,
      pageSize: SIZE_OF_PAGE,
    };

    if (query !== previousQuery) {
      setCurrentPage(1);
    }

    dispatch(getAllPermissions(body));
    setPreviousQuery(query);
  }, [currentPage, query, dispatch, previousQuery]);

  const PermissionsData = permissions?.map((permission) => ({
    ...permission,
  }));
  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Description", accessor: "description" },
  ];

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="main-container">
        <div className="content-header">
          <div className="header-navigation">
            <BodySmallMedium text="Manage" color="#A1A2A4" />
            <img
              src={chevron_rightIcon}
              alt="Chevron Right"
              className="chevron-right-icon"
            />
            <BodySmallMedium text="Permissions" color="#1E293B" />
          </div>
        </div>

        <Heading6Regular text="Permissions" color="#1E293B" />
        <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={handleSearchChange}
              value={query}
            />
            <CustomPagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <DynamicTable
            data={PermissionsData}
            isLoading={permissionsData === "isLoading"}
            columns={columns}
            thIcon={thIcon}
          />
        </div>
      </div>
    </>
  );
}

export default Permissions;
